import { observer } from "mobx-react-lite";
import React from "react";
import { Parameter } from "./parameter/Parameter";
import { stores } from "../stores";
import "./Preset.css";

export const Preset = observer(() => {
    const presetNumber = stores.state.activePreset;
    const deviceType = stores.memory.getDeviceType();

    const getBankAndFolder = (presetNumber: number): { folderNumber: number; bankName: string; bankColor: string; textColor: string } => {
        const folderNumber = Math.ceil(presetNumber / 12);
        const bankNumber = ((presetNumber - 1) % 12) + 1;
        let bankColor: string;
        let bankName: string;
        let textColor: string;
        if (bankNumber <= 4) {
            bankColor = 'red';
            bankName = 'Red';
            textColor = 'white';
        } else if (bankNumber <= 8) {
            bankColor = 'yellow';
            bankName = 'Yellow';
            textColor = 'black';
        } else {
            bankColor = 'violet';
            bankName = 'Violet';
            textColor = 'white';
        }
        return { folderNumber, bankName, bankColor, textColor };
    };

    const renderPresetInfo = () => {
        if (deviceType !== "DPC-8EZ Gen3") {
            return null; // Hide bank/folder info for devices other than DPC-8EZ Gen3
        }

        if (presetNumber === 0) {
            return (
                <div className="bypass-info" style={{
                    marginBottom: '1rem',
                    backgroundColor: 'orange',
                    padding: '5px 10px',
                    display: 'inline-block',
                    borderRadius: '4px'
                }}>
                    <span style={{ color: 'black' }}>Bypass</span>
                </div>
            );
        } else {
            const { folderNumber, bankName, bankColor, textColor } = getBankAndFolder(presetNumber);
            return (
                <div className="bank-folder-info" style={{
                    marginBottom: '1rem',
                    display: 'flex',
                    gap: '5px'
                }}>
                    <span style={{
                        backgroundColor: bankColor,
                        color: textColor,
                        padding: '5px 10px',
                        borderRadius: '4px'
                    }}>
                        {bankName} Bank
                    </span>
                    <span style={{
                        backgroundColor: 'green',
                        color: 'white',
                        padding: '5px 10px',
                        borderRadius: '4px'
                    }}>
                        Folder {folderNumber}
                    </span>
                </div>
            );
        }
    };

    return (
    <div className="preset">
        <div className="title">
            Preset #{presetNumber}
        </div>
        {renderPresetInfo()}
        {deviceType === "DPC-8EZ Gen3" ? (
            <>
                <Parameter parameterId={"NAME"} presetNumber={presetNumber} />
                <Parameter parameterId={"LOOP_STATUS2"} presetNumber={presetNumber} />
                <Parameter parameterId={"LOOP_STATUS"} presetNumber={presetNumber} />
                <Parameter parameterId={"LOOP_STATUS3"} presetNumber={presetNumber} />
                <Parameter parameterId={"DONT_CARE"} presetNumber={presetNumber} />
                <Parameter parameterId={"PROGRAMA"} presetNumber={presetNumber} />
                <Parameter parameterId={"PROGRAMB"} presetNumber={presetNumber} />
            </>
        ) : (
            <>
                <Parameter parameterId={"NAME"} presetNumber={presetNumber} />
                <Parameter parameterId={"LOOP_STATUS_micro"} presetNumber={presetNumber} />
                <Parameter parameterId={"PROGRAM_micro"} presetNumber={presetNumber} />
                <div className="cc-group">
                    <Parameter parameterId={"CCCHA_micro"} presetNumber={presetNumber} />
                    <Parameter parameterId={"CCNUMA_micro"} presetNumber={presetNumber} />
                    <Parameter parameterId={"CCVALA_micro"} presetNumber={presetNumber} />
                </div>
                <div className="cc-group">
                    <Parameter parameterId={"CCCHB_micro"} presetNumber={presetNumber} />
                    <Parameter parameterId={"CCNUMB_micro"} presetNumber={presetNumber} />
                    <Parameter parameterId={"CCVALB_micro"} presetNumber={presetNumber} />
                </div>
            </>
        )}
    </div>
);

    // return (
    //     <div className="preset">
    //         <div className="title">
    //             Preset #{presetNumber}
    //         </div>
    //         {renderPresetInfo()}
    //         {deviceType === "DPC-8EZ Gen3" ? (
    //             <>
    //                 <Parameter parameterId={"NAME"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"LOOP_STATUS2"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"LOOP_STATUS"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"LOOP_STATUS3"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"DONT_CARE"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"PROGRAMA"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"PROGRAMB"} presetNumber={presetNumber} />
    //             </>
    //         ) : (
    //             <>
    //                 <Parameter parameterId={"NAME"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"LOOP_STATUS_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"PROGRAM_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"CCCHA_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"CCNUMA_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"CCVALA_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"CCCHB_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"CCNUMB_micro"} presetNumber={presetNumber} />
    //                 <Parameter parameterId={"CCVALB_micro"} presetNumber={presetNumber} />
    //             </>
    //         )}
    //     </div>
    // );
});